

/**
 * @typedef {Object} AppConfig
 * @property {string} priceListUploadUrl
 */

/**
 * @returns {AppConfig}
 */
export function getAppConfig() {

  const el = document.getElementById("app-config");

  if (!el) {
    throw new Error("Missing #app-data script tag");
  }
  try {
    return JSON.parse(el.textContent);
  } catch (err) {
    throw new Error("Invalid JSON in #app-data");
  }
}
